import regionFile from './assets/region1.json'

let regionDictionary: Record<string, Record<string, string>> | null = null
let regionData: string[] | null = null
let regionIndex: Record<string, number[]> | null = null

export function data (): string[] {
  if (!regionData) {
    regionData = regionFile.data
  }
  return regionData ?? []
}

export function dictionary (): Record<string, Record<string, string>> {
  if (!regionDictionary) {
    regionDictionary = regionFile.dictionary
  }
  return regionDictionary!
}

export function index (): Record<string, number[]> {
  if (!regionIndex) {
    regionIndex = regionFile.index
  }
  return regionIndex ?? {}
}
